// extracted by mini-css-extract-plugin
export default {"alert":"AuthAlert_alert__Px4Uj","success":"AuthAlert_success__zaHPz","error":"AuthAlert_error__N47dj"};